import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { dtsEventCategoryListres } from "../../../pages/main-pages/dts/event-category/list/EventCategoryList";

interface eventCategorySliceReducer {
  eventCategoryListRedux: dtsEventCategoryListres[];
}

const initialState: eventCategorySliceReducer = {
  eventCategoryListRedux: [],
};

const eventCategorySlice = createSlice({
  name: "eventCategory",
  initialState,
  reducers: {
    setEventCategoryListRedux: (
      state,
      action: PayloadAction<dtsEventCategoryListres[]>,
    ) => {
      state.eventCategoryListRedux = action.payload;
    },
  },
});

export const { setEventCategoryListRedux } = eventCategorySlice.actions;

export default eventCategorySlice.reducer;
